import DrivingApi from "./../api/drivingApi";
import { getDefaultDrivingConfiguration } from "./../utilities/driving";

export const GET_DRIVING_DATA_REQUESTED = "driving/GET_DRIVING_DATA_REQUESTED";
export const GET_DRIVING_DATA = "driving/GET_DRIVING_DATA";
export const DOWNLOAD_DRIVING_XLS = "driving/DOWNLOAD_DRIVING_XLS";
export const SAVE_DRIVING_CONFIGURATION_REQUESTED =
  "driving/SAVE_DRIVING_CONFIGURATION_REQUESTED";
export const SAVE_DRIVING_CONFIGURATION = "driving/SAVE_DRIVING_CONFIGURATION";
export const GET_DRIVING_CONFIGURATION_REQUEST =
  "driving/GET_DRIVING_CONFIGURATION_REQUEST";
export const GET_DRIVING_CONFIGURATION = "driving/GET_DRIVING_CONFIGURATION";
export const DRIVING_CONFIGURATION_REQUEST_ERROR =
  "driving/DRIVING_CONFIGURATION_REQUEST_ERROR";
export const GET_DRIVING_DATA_REQUEST_ERROR =
  "driving/GET_DRIVING_DATA_REQUEST_ERROR";

const initialState = {
  configuration: {
    isLoading: false,
    data: getDefaultDrivingConfiguration()
  },
  data: {
    Unidades: [],
    FechaInicial: null,
    FechaFinal: null,
    FechaPrimeraUbicacion: null,
    FechaUltimaUbicacion: null,
    UnidadDistancia: "Km",
    ReporteGeneral: {},
    Trayectos: []
  },
  isLoading: false,
  hasData: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_DRIVING_DATA_REQUESTED:
      return {
        ...state,
        isLoading: true
      };

    case GET_DRIVING_DATA:
      return {
        ...state,
        isLoading: false,
        hasData: true,
        data: action.data
      };

    case SAVE_DRIVING_CONFIGURATION_REQUESTED:
      return {
        ...state,
        configuration: {
          ...state.configuration,
          isLoading: true
        }
      };

    case SAVE_DRIVING_CONFIGURATION:
      return {
        ...state,
        configuration: {
          data: Object.assign({}, action.data),
          isLoading: false
        }
      };

    case GET_DRIVING_CONFIGURATION_REQUEST:
      return {
        ...state,
        configuration: {
          data: state.configuration.data,
          isLoading: true
        }
      };

    case GET_DRIVING_CONFIGURATION:
      return {
        ...state,
        configuration: {
          data: Object.assign({}, action.data),
          isLoading: false
        }
      };

    case GET_DRIVING_DATA_REQUEST_ERROR:
      return {
        ...state,
        isLoading: false
      };

    case DRIVING_CONFIGURATION_REQUEST_ERROR:
      return {
        ...state,
        configuration: {
          ...state.configuration,
          isLoading: false
        }
      };

    default:
      return state;
  }
};

export const getDrivingData = config => {
  return dispatch => {
    dispatch({
      type: GET_DRIVING_DATA_REQUESTED
    });

    if (process.env.NODE_ENV === "development") {
      return DrivingApi.getDrivingDataFake(config)
        .then(data => {
          dispatch({
            type: GET_DRIVING_DATA,
            data
          });
        })
        .catch(error => {
          dispatch({
            type: GET_DRIVING_DATA_REQUEST_ERROR
          });
          throw error;
        });
    } else {
      return DrivingApi.getDrivingData(config)
        .then(data => {
          dispatch({
            type: GET_DRIVING_DATA,
            data
          });
        })
        .catch(error => {
          dispatch({
            type: GET_DRIVING_DATA_REQUEST_ERROR
          });
          throw error;
        });
    }
  };
};

export const saveDrivingConfiguration = config => {
  return dispatch => {
    dispatch({
      type: SAVE_DRIVING_CONFIGURATION_REQUESTED
    });

    return DrivingApi.saveDrivingConfiguration(config)
      .then(data => {
        dispatch({
          type: SAVE_DRIVING_CONFIGURATION,
          data
        });
      })
      .catch(error => {
        dispatch({
          type: DRIVING_CONFIGURATION_REQUEST_ERROR
        });
        throw error;
      });
  };
};

export const getDrivingConfiguration = () => {
  return dispatch => {
    dispatch({
      type: GET_DRIVING_CONFIGURATION_REQUEST
    });

    if (process.env.NODE_ENV === "development") {
      return DrivingApi.getDrivingConfigurationFake()
        .then(data => {
          dispatch({
            type: GET_DRIVING_CONFIGURATION,
            data
          });
        })
        .catch(err => {
          dispatch({
            type: DRIVING_CONFIGURATION_REQUEST_ERROR
          });
        });
    } else {
      return DrivingApi.getDrivingConfiguration()
        .then(data => {
          dispatch({
            type: GET_DRIVING_CONFIGURATION,
            data
          });
        })
        .catch(err => {
          dispatch({
            type: DRIVING_CONFIGURATION_REQUEST_ERROR
          });
        });
    }
  };
};



// WEBPACK FOOTER //
// ./src/modules/driving.js